import React from 'react';
import { isHtml } from '../../utils/util';
import './OnePopUpComment.css';
import intl from 'react-intl-universal';

export default class OnePopUpComment extends React.Component {
  state = {
    to0: false
  };
  componentDidMount() {
    //因为该元素最长持续时间只有9秒，所以时间必须小于9秒
    this.timer = setTimeout(() => {
      this.setState({
        to0: true
      });
    }, 8500);
  }
  componentWillUnmount() {
    clearTimeout(this.timer);
  }
  render() {
    const { props } = this;
    const { type = 1, name } = props;

    let { content, master } = props;
    const REDPACK_STRING = '$$REDPACKAGE';
    const redpackIndex = content.indexOf(REDPACK_STRING);
    if (redpackIndex === 0) {
      try {
        let contentObj = JSON.parse(content.slice(REDPACK_STRING.length));
        // console.log(contentObj.content);
        content = `${intl.get("Red packet's coming! ")}${name} : ${
          contentObj.content
        }`;
      } catch (e) {
        content = `${intl.get("Red packet's coming! ")}`;
      }
    } else {
      try {
        content = decodeURIComponent(content);
      } catch (e) {
        content = '';
      }
    }

    return (
      <div
        className={
          'one-pop-up-wrapper ' + (this.state.to0 ? 'height-to-0' : '')
        }
      >
        <div className={'animate__fadeInUp animate__animated one-popup-comment type' + type}>
          <img
            alt=""
            className="one-popup-comment-avatar"
            src={props.photo || require('../../assets/logo-128.jpg')}
          />
          {isHtml(content) && master * 1 ? (
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          ) : (
            <div className="content">{content}</div>
          )}
        </div>
      </div>
    );
  }
}
